import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../nest-api";
import { responseObj } from "../nest-model/nest-model";
import { NestResponsesProvider, ResponseData } from "../nest-responses";

@Injectable()
export class CustomerApi {

  private service: string = '';
  private model: string = 'erp/customer';

  constructor(
    public nestApiProvider: NestApiProvider,
    public nestResponseProvider: NestResponsesProvider,
  ) {
  }

  public getListCustomer(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getListCustomer';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this.model, _func, _params, _urlParams, this.service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public getComponentInputCustomer(payload: { id: number}): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getComponentInputCustomer';
    const _params: any = payload || {};
    const _urlParams: any = payload;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this.model, _func, _params, _urlParams, this.service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public getDetailCustomer(payload: { identity: number}): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getDetailCustomer';
    const params: any = payload || {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  add(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "add";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = formData;
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  update(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "update";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = formData;
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  delete(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "delete";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = formData;
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

}


// WEBPACK FOOTER //
// ./src/shared/nestjs/erp/customer.api.ts